import { render } from "./top-nav.vue?vue&type=template&id=648454d1&ts=true"
import script from "./top-nav.vue?vue&type=script&lang=ts"
export * from "./top-nav.vue?vue&type=script&lang=ts"

import "./top-nav.vue?vue&type=style&index=0&id=648454d1&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__